import {
  Button,
  Tabs,
  Form,
  Row,
  Col,
  Tooltip,
  Input,
  Select,
  Checkbox,
  Tag,
  Collapse,
  Radio,
  Spin,
  Typography,
} from "antd";

import React, { createRef, useEffect, useState } from "react";
import "../../styles/components.scss";
import { HeaderUser } from "../../components/HeaderUser";
import { FormattedMessage } from "react-intl";
import {
  getClinicsApi,
  getListTemplatesUser,
  toAddAssessment,
  toUpdateAssessment,
} from "../../utils/APIs";

import {
  dataSuperior,
  getPDF,
  getTranslatedValue,
  successMsg,
  toCalculateResult,
} from "../../utils/Utils";
import NumberOfCasesStore from "../../DataStores/NumberOfCasesStore";
import WorkflowStore from "../../DataStores/WorkflowStore";
import { BiReset } from "react-icons/bi";

import { inject, observer } from "mobx-react";
import ConversionStatisticsStore from "../../DataStores/ConversionStatisticsStore";
import NumberOfCases from "./sections/NumberOfCases";
import TimeSpentStore from "../../DataStores/TimeSpentStore";
import ConversionStatistics from "./sections/ConversionStatistics";
import TimeSpent from "./sections/TimeSpent";
import WorkflowTreatment from "./sections/WorkflowTreatment";
import { toJS } from "mobx";
import { useIndexedDBStore } from "use-indexeddb";
import { useLocation, useNavigate } from "react-router-dom";
import cookie from "react-cookies";
import moment from "moment";
import GoalsStore from "../../DataStores/GoalsStore";
import Goals from "./sections/Goals";
import { ReloadOutlined } from "@ant-design/icons";
import { LoadingOutlined } from "@ant-design/icons";
import ScreenLoader from "../../components/ScreenLoader";

const { Option } = Select;

const { TabPane } = Tabs;

const antIcon = <LoadingOutlined style={{ fontSize: 14 }} spin />;

const Tool = ({ ToolStore, ResultsStore }) => {
  const navigate = useNavigate();

  const { getByID } = useIndexedDBStore("assessments");
  const { deleteAll } = useIndexedDBStore("templates");
  const { getAll } = useIndexedDBStore("templates");
  const { add } = useIndexedDBStore("templates");
  const db = useIndexedDBStore("settingsUser");
  const dbAssessments = useIndexedDBStore("assessments");

  const location = useLocation();
  const [id, setId] = useState(null != location.state ? location.state.id : -1);
  const [step, setStep] = useState(1);
  const [formPractice] = Form.useForm();

  const [loading, setLoading] = useState(true);
  const [font, setFontSize] = useState(cookie.load("font"));
  const [templates, setTemplates] = useState([]);
  const [activeKey, setActiveItem] = useState(-1);
  const [doctorId, setDoctorId] = useState(null);
  const [clinicId, setClinicId] = useState(null);
  const [clinic, setClinic] = useState({
    id: -1,
    name: "",
    address: null,
    doctors: [],
  });
  const [doctor, setDoctor] = useState({ id: -1, name: null, email: null });
  const [clinics, setClinics] = useState([]);
  const [clinicsAll, setClinicsAll] = useState([]);
  const [draftData, setDraftData] = useState(true);
  const [loadingClinics, setLoadingClinics] = useState(true);
  const getTemplateId = async () => {
    return await db.getAll();
  };
  useEffect(() => {
    var templateId = -1;
    var data = null;
    var clinicId = null;
    var doctorId = null;
    if (id != -1) {
      getByID(id).then((res) => {
        templateId = res.templateId;
        data = res.results;
        clinicId = res.clinicId;
        doctorId = res.doctorId;

        setClinicId(clinicId);
        setDoctorId(doctorId);
        setStep(3);
        // getClinicsToEdit(clinicId, doctorId);
      });
    } else {
      getTemplateId().then((a) => {
        if (a.length > 0) {
          templateId = a[0].templateId;
        }
      });
      getClinics();
    }

    ToolStore.reset();
    NumberOfCasesStore.reset();
    WorkflowStore.reset();
    ConversionStatisticsStore.reset();
    TimeSpentStore.reset();
    getListTemplatesUser()
      .then((res) => {
        deleteAll();
        res.forEach((element) => {
          try {
            add(element);
          } catch (error) {
            console.log({ error });
          }
        });
        toFormatListTemplates(templateId, data);
      })
      .catch((e) => {
        toFormatListTemplates(templateId, data);
      });
  }, []);

  const toFormatListTemplates = (templateId, data) => {
    var initialPanes = [];
    getAll().then((res) => {
      res.forEach((element) => {
        if (
          element.data
            .filter((a) => a.fieldName == "practiceProfile")[0]
            .value.filter((a) => a.fieldName == "numberClinics") == 0
        ) {
          element.data
            .filter((a) => a.fieldName == "practiceProfile")[0]
            .value.push({
              value: 1,
              display: true,
              fieldName: "numberClinics",
            });
        }
        initialPanes.push({
          symbol: element.symbol,
          currency: element.currency,
          title: element.name,
          content: element.name,
          indicators: element.indicators,
          key: element.id + "",
          dso: element.dso,
          id: element.id,
          visible: false,
          practiceProfile:
            id != -1 && templateId == element.id
              ? data.filter((a) => a.fieldName == "practiceProfile")
              : element.data.filter((a) => a.fieldName == "practiceProfile"),
          numberOfCases:
            id != -1 && templateId == element.id
              ? data.filter((a) => a.fieldName == "numberOfCases")
              : element.data.filter((a) => a.fieldName == "numberOfCases"),
          conversionStatistics:
            id != -1 && templateId == element.id
              ? data.filter((a) => a.fieldName == "conversionStatistics")
              : element.data.filter(
                  (a) => a.fieldName == "conversionStatistics"
                ),
          timeSpentOnTheExam:
            id != -1 && templateId == element.id
              ? data.filter((a) => a.fieldName == "timeSpentOnTheExam")
              : element.data.filter((a) => a.fieldName == "timeSpentOnTheExam"),
          workflowTreatement:
            id != -1 && templateId == element.id
              ? data.filter((a) => a.fieldName == "workflowTreatment")
              : element.data.filter((a) => a.fieldName == "workflowTreatment"),
          goalsAndObjectives:
            id != -1 && templateId == element.id
              ? data.filter((a) => a.fieldName == "goalsAndObjectives")
              : element.data.filter((a) => a.fieldName == "goalsAndObjectives"),

          inputs: element.inputs,

          data: id != -1 && templateId == element.id ? data : element.data,
        });
      });

      if (initialPanes.length > 0) {
        var index = initialPanes.findIndex((e) => e.key == templateId);
        if (index == -1) {
          index = 0;
        }
        updateSelectedItem(initialPanes[index]);
        ToolStore.setTemplates(initialPanes);

        GoalsStore.setDefaultsValues();
        GoalsStore.setChanged(GoalsStore.toFormatChanged());

        NumberOfCasesStore.setDefaultsValues();
        NumberOfCasesStore.setChanged(NumberOfCasesStore.toFormatChanged());

        WorkflowStore.setDefaultsValues();
        WorkflowStore.setChanged(WorkflowStore.toFormatChanged());

        ConversionStatisticsStore.setDefaultsValues();
        ConversionStatisticsStore.setChanged(
          ConversionStatisticsStore.toFormatChanged()
        );

        TimeSpentStore.setDefaultsValues();
        TimeSpentStore.setChanged(TimeSpentStore.toFormatChanged());
        ToolStore.toChangeConditions();
        setActiveItem(initialPanes[index].key + "");
        setTemplates(initialPanes);
      }
      setTimeout(() => {
        setLoading(false);
      }, 500);
    });
  };

  const OnChange = (activeKey) => {
    var selected = templates.find((i) => i.key == activeKey);
    updateSelectedItem(selected);
    NumberOfCasesStore.setDefaultsValues();
    NumberOfCasesStore.setChanged(NumberOfCasesStore.toFormatChanged());

    WorkflowStore.setDefaultsValues();
    WorkflowStore.setChanged(WorkflowStore.toFormatChanged());

    ConversionStatisticsStore.setDefaultsValues();
    ConversionStatisticsStore.setChanged(
      ConversionStatisticsStore.toFormatChanged()
    );
    TimeSpentStore.setDefaultsValues();
    TimeSpentStore.setChanged(TimeSpentStore.toFormatChanged());
    setActiveItem(activeKey);
  };

  const tagRender = (props) => {
    const { label, value, closable, onClose } = props;

    return (
      <Tag
        color={"#EEEEEE"}
        closable={closable}
        onClose={onClose}
        style={{
          marginRight: 3,
          fontFamily: "Gotham",
          fontStyle: "normal",
          fontWeight: "normal",
          fontSize: "20px",
          lineHeight: "20px",

          color: "#000000",
        }}
      >
        {label}
      </Tag>
    );
  };
  const getValue = (data, name) => {
    var res = "";
    data[0].value.forEach((element) => {
      if (element.fieldName == "products") {
        element.value.forEach((sub) => {
          if (sub.fieldName == name) {
            res = sub.value;
          }
        });
      }
      if (element.fieldName == name) {
        res = element.value;
      }
    });

    return res;
  };
  const onFinish = () => {
    setStep(step + 1);
  };

  const updateSelectedItem = (data) => {
    ToolStore.setSelectedItem(data);
    ToolStore.toChangeSeparateTeens(ToolStore.conditions.separateTeensAdults);
  };

  const onChangeFormPractice = () => {
    ToolStore.onChangePracticeProfileData(formPractice.getFieldsValue());
  };

  const getClinicsToEdit = (clinicId, doctorId) => {
    setLoadingClinics(true);

    getClinicsApi().then((l) => {
      setLoadingClinics(false);
      if (l[0].token == null) {
        window.location.replace(
          process.env.REACT_APP_URL_SF +
            "/services/oauth2/authorize?client_id=" +
            process.env.REACT_APP_SF_CLIENT_ID +
            "&redirect_uri=" +
            process.env.REACT_APP_SF_REDIRECT_URI +
            "&response_type=code"
        );
      } else {
        if (clinicId != null && clinicId != -1) {
          var l__clinic = l[0].clinics.find((e) => e.id == clinicId);
          if (l__clinic) {
            var l__doctor = l__clinic.doctors.find((e) => e.id == doctorId)
              ? l__clinic.doctors.find((e) => e.id == doctorId)
              : {
                  id: doctorId,
                  name: formPractice.getFieldValue("doctorName"),
                  email: formPractice.getFieldValue("email"),
                };
          } else {
            l__clinic = {
              id: clinicId,
              name: formPractice.getFieldValue("clinicName"),
              address: formPractice.getFieldValue("adress"),
              doctors: [],
            };
            l__doctor = {
              id: doctorId,
              name: formPractice.getFieldValue("doctorName"),
              email: formPractice.getFieldValue("email"),
            };
          }
          setDoctor(l__doctor);
          setClinic(l__clinic);
        } else {
          setDraftData(true);
          setClinic({
            id: -1,
            name: formPractice.getFieldValue("clinicName"),
            address: formPractice.getFieldValue("adress"),
          });

          setDoctor({
            id: -1,
            name: formPractice.getFieldValue("doctorName"),
            email: formPractice.getFieldValue("email"),
          });
        }
        setClinics(l[0].clinics);
        setClinicsAll(l[0].clinics);
      }
    });
  };

  const getClinics = () => {
    setLoadingClinics(true);

    getClinicsApi().then((l) => {
      setLoadingClinics(false);
      /*if (l[0].token == null) {
        window.location.replace(
          process.env.REACT_APP_URL_SF +
            "/services/oauth2/authorize?client_id=" +
            process.env.REACT_APP_SF_CLIENT_ID +
            "&redirect_uri=" +
            process.env.REACT_APP_SF_REDIRECT_URI +
            "&response_type=code"
        );
      } else {
        setClinics(l[0].clinics);
        setClinicsAll(l[0].clinics);
      }*/
    });
  };

  const getDoctor = (e) => {
    var c = clinics.find((i) => i.id == clinic.id);
    return c.doctors.find((i) => i.name == e)
      ? c.doctors.find((i) => i.name == e)
      : [];
  };

  const changeClinic = (e) => {
    var clinic = clinics.filter((clinic) => clinic.name == e)[0];
    setClinic(clinic);
    var doctors = clinic.doctors;
    var data = formPractice.getFieldsValue();
    if (doctors.length > 0) {
      setDoctor({
        id: doctors[0].id,
        name: doctors[0].name,
        email: doctors[0].email,
      });
      data.doctorName = doctors[0].name;
      data.email = doctors[0].email;
    } else {
      data.doctorName = null;
      data.email = null;
    }
    data.adress = clinic.address;
    data.clinicName = clinic.name;
    formPractice.setFieldsValue(data);
    onChangeFormPractice();
  };

  const setEmail = (e) => {
    var data = formPractice.getFieldsValue();
    data.email = e;
    formPractice.setFieldsValue(data);
    onChangeFormPractice();
  };

  const changeDoctor = (e) => {
    var doctor = getDoctor(e);
    setDoctor({
      id: doctor.id,
      name: doctor.name,
      email: doctor.email,
    });
    setEmail(doctor.email);
  };

  const fillDraftPracticeData = () => {
    var data = formPractice.getFieldsValue();
    data.clinicName = "Clinic Test";
    data.adress = "Address Test";
    data.doctorName = "Doctor Test";
    data.email = "emailtest@dentalmonitoring-emailtest.com";

    setClinic({
      id: -1,
      name: data.clinicName,
      address: data.adress,
    });

    setDoctor({
      id: -1,
      name: data.doctorName,
      email: data.email,
    });

    setDraftData(true);

    formPractice.setFieldsValue(data);
    onChangeFormPractice();
  };

  const resetAssessment = () => {
    OnChange(ToolStore.selectedItem.key);

    if (id == -1) {
      setClinic({
        id: -1,
        name: "",
        address: null,
        doctors: [],
      });

      setDoctor({
        id: -1,
        name: null,
        email: null,
      });
    } else {
      var selected = templates.find((i) => i.key == activeKey);

      var json = {};
      var data = selected.practiceProfile;
      data[0].value.forEach((element) => {
        if (element.fieldName == "products") {
          element.value.forEach((sub) => {
            json[sub.fieldName] = getValue(data, sub.fieldName);
          });
        } else {
          json[element.fieldName] = element.value;
        }
      });

      json.speciality = json.speciality != "" ? json.speciality : [];
      setClinic({
        id: clinicId,
        name: json.clinicName,
        address: json.adress,
        doctors: clinics.find((i) => i.id == clinicId)
          ? clinics.find((i) => i.id == clinicId).doctors
          : [],
      });

      setDoctor({
        id: doctorId,
        name: json.doctorName,
        email: json.email,
      });
    }

    setDraftData(false);
  };

  const practiceProfile = (data) => {
    var json = {};
    data[0].value.forEach((element) => {
      if (element.fieldName == "products") {
        element.value.forEach((sub) => {
          json[sub.fieldName] = getValue(data, sub.fieldName);
        });
      } else {
        json[element.fieldName] = element.value;
      }
    });

    json.speciality = json.speciality != "" ? json.speciality : [];
    formPractice.setFieldsValue(json);

    var dsiplayseparateTeensAdults = data[0].value.filter(
      (b) => b.fieldName == "separateTeensAdults"
    )[0].display;
    var dsiplayshowHourly = data[0].value.filter(
      (b) => b.fieldName == "showHourly"
    )[0].display;

    var dsiplayseparateRole = data[0].value.filter(
      (b) => b.fieldName == "separateRole"
    )[0].display;

    const sortInputFirst = (input, data) => {
      var first = [];
      var others = [];
      for (var i = 0; i < data.length; i++) {
        if (data[i].name.toUpperCase().indexOf(input.toUpperCase()) >= 0) {
          if (data[i].name.toUpperCase().indexOf(input.toUpperCase()) == 0) {
            first.push(data[i]);
          } else {
            others.push(data[i]);
          }
        }
      }
      first.sort();
      others.sort();

      setClinics(first.concat(others));
    };

    return (
      <Collapse defaultActiveKey={["1"]} expandIconPosition="right">
        <Collapse.Panel
          className="roi--collapse-header-green"
          header={
            <span style={{ fontSize: font * 28 + "px" }}>
              {ToolStore.selectedItem.dso ? (
                <FormattedMessage id="dsoProfile" />
              ) : (
                <FormattedMessage id="practiceProfile" />
              )}
            </span>
          }
          key="1"
        >
          <Form
            form={formPractice}
            name="pricing"
            onFinish={onFinish}
            onChange={onChangeFormPractice}
          >
            {step > 0 && (
              <>
                {/* {!ToolStore.selectedItem.dso && (
                  <Row>
                    <Col span="12">
                      <Button
                        className="roi--button-open-saved"
                        onClick={() => fillDraftPracticeData()}
                        style={{ float: "left" }}
                      >
                        <FormattedMessage id="practiceDraftData" />
                      </Button>
                      <Button
                        className="roi--button-open-saved"
                        onClick={() => resetAssessment()}
                        style={{ float: "left", marginLeft: "10px" }}
                      >
                        <span style={{ marginLeft: "5px" }}>
                          <FormattedMessage id="ressetAssessment" />
                        </span>
                      </Button>
                    </Col>
                    <Col span="10">
                      <Button
                        onClick={() => getClinics()}
                        icon={
                          loadingClinics ? (
                            <Spin indicator={antIcon} />
                          ) : (
                            <ReloadOutlined />
                          )
                        }
                        className="roi--button-open-saved"
                      >
                        <span style={{ marginLeft: "5px" }}>
                          <FormattedMessage id="getDataFromSF" />
                        </span>
                      </Button>
                    </Col>
                  </Row>
                )} */}

                <Row style={{ marginTop: "4vh" }}>
                  <Col xl={10} md={24}>
                    <Row>
                      <Col xl={2} md={2}>
                        <Tooltip
                          color="#EBEBEA"
                          fontFamily="Gotham"
                          fontSize="20px"
                          style={{ textColor: "#6a6e80", textAlign: "right" }}
                          placement="rightTop"
                          title={
                            <FormattedMessage
                              id={
                                ToolStore.selectedItem.dso
                                  ? "nameDSOTooltip"
                                  : "nameClinicTooltip"
                              }
                            />
                          }
                        >
                          <img src="/images/icons/bull.svg" />
                        </Tooltip>
                      </Col>
                      <Col md={12} xl={13}>
                        <span className="roi--label-section">
                          {ToolStore.selectedItem.dso ? (
                            <FormattedMessage id="dsoName" />
                          ) : (
                            <FormattedMessage id="clinicName" />
                          )}
                        </span>
                      </Col>
                      <Col md={7} xl={9}>
                        <div className="roi--select-tool">
                          <Form.Item
                            name="clinicName"
                            rules={[
                              {
                                required: true,
                                message: "",
                              },
                            ]}
                          >
                            {ToolStore.selectedItem.dso || draftData ? (
                              <Input />
                            ) : (
                              <Select
                                showSearch
                                className="roi--select-tool"
                                loading={loadingClinics}
                                placeholder={
                                  <FormattedMessage id="selectClinic" />
                                }
                                showArrow
                                onSearch={(e) => sortInputFirst(e, clinicsAll)}
                                onChange={(e) => changeClinic(e)}
                                defaultValue={clinic.id != -1 && clinic.id}
                              >
                                {clinics.map((clinic, i) => (
                                  <Option key={i} value={clinic.name}>
                                    {clinic.name}
                                  </Option>
                                ))}
                              </Select>
                            )}
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col xl={2} md={0} xs={0}></Col>
                  <Col xl={10} md={24}>
                    <Row>
                      <Col xl={2} md={2}>
                        <Tooltip
                          color="#EBEBEA"
                          fontFamily="Gotham"
                          fontSize="20px"
                          style={{ textColor: "#6a6e80" }}
                          placement="rightTop"
                          title={
                            <FormattedMessage
                              id={
                                ToolStore.selectedItem.dso
                                  ? "specialitiesDSOTooltip"
                                  : "specialitiesTooltip"
                              }
                            />
                          }
                        >
                          <img src="/images/icons/bull.svg" />
                        </Tooltip>
                      </Col>

                      <Col md={12} xl={13}>
                        <span className="roi--label-section">
                          <FormattedMessage id="speciality" />
                        </span>
                      </Col>
                      <Col md={7} xl={9}>
                        <Form.Item
                          name="speciality"
                          rules={[
                            {
                              required: true,
                              message: "",
                            },
                          ]}
                        >
                          <Select
                            mode="multiple"
                            showArrow
                            onChange={(e) =>
                              ToolStore.onChangePracticeProfileData(
                                formPractice.getFieldsValue()
                              )
                            }
                            tagRender={tagRender}
                            style={{ width: "100%" }}
                          >
                            <Option value="Orthodontics">
                              <FormattedMessage id="Orthodontics" />
                            </Option>
                            <Option value="Implantologist">
                              <FormattedMessage id="Implantologist" />
                            </Option>
                            <Option value="Endodontist">
                              <FormattedMessage id="Endodontist" />
                            </Option>
                            <Option value="Periodontist">
                              <FormattedMessage id="Periodontist" />
                            </Option>
                            <Option value="OralSurgeon">
                              <FormattedMessage id="OralSurgeon" />
                            </Option>
                            <Option value="Hygienist">
                              <FormattedMessage id="Hygienist" />
                            </Option>
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>{" "}
                </Row>

                <Row>
                  <Col xl={10} md={24}>
                    <Row>
                      <Col xl={2} md={2}></Col>
                      <Col md={12} xl={13}>
                        <span className="roi--label-section">
                          <FormattedMessage id="Adress" />
                        </span>
                      </Col>
                      <Col md={7} xl={9}>
                        <Form.Item
                          name="adress"
                          rules={[
                            {
                              required: true,
                              message: "",
                            },
                          ]}
                        >
                          {ToolStore.selectedItem.dso ? (
                            <Input />
                          ) : (
                            <Input
                            // disabled={
                            //   clinic.name != "" && clinic.name != null
                            //     ? false
                            //     : true
                            // }
                            />
                          )}
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                  <Col xl={2} md={0} xs={0}></Col>
                  <Col xl={10} md={24}>
                    <Row>
                      <Col xl={2} md={2}></Col>

                      <Col md={12} xl={13}>
                        <span className="roi--label-section">
                          <FormattedMessage id="openDays" />
                        </span>
                      </Col>
                      <Col md={7} xl={9}>
                        <Form.Item
                          name="openDays"
                          rules={[
                            {
                              required: true,
                              message: "",
                            },
                          ]}
                        >
                          <Form.Item
                            name="openDays"
                            defaultValue={5}
                            rules={[
                              {
                                validator: dataSuperior,
                              },
                            ]}
                          >
                            <Input
                              type="number"
                              suffix={
                                getTranslatedValue("day") +
                                "/" +
                                getTranslatedValue("week")
                              }
                            />
                          </Form.Item>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>{" "}
                </Row>
                <Row>
                  <Col xl={10} md={24}>
                    <Row>
                      <Col xl={2} md={2}></Col>
                      <Col md={12} xl={13}>
                        <span className="roi--label-section">
                          {ToolStore.selectedItem.dso ? (
                            <FormattedMessage id="dsoContact" />
                          ) : (
                            <FormattedMessage id="doctorName" />
                          )}
                        </span>
                      </Col>
                      <Col md={7} xl={9}>
                        <div className="roi--select-tool">
                          <Form.Item
                            name="doctorName"
                            rules={[
                              {
                                required: true,
                                message: "",
                              },
                            ]}
                          >
                            {ToolStore.selectedItem.dso || draftData ? (
                              <Input />
                            ) : (
                              <Select
                                showSearch
                                showArrow
                                className="roi--select-tool"
                                placeholder={
                                  <FormattedMessage id="selectDoctor" />
                                }
                                onChange={(e) => changeDoctor(e)}
                                disabled={
                                  clinic.name != "" && clinic.name != null
                                    ? false
                                    : true
                                }
                              >
                                {clinic.name != "" ? (
                                  clinic.doctors.map((doctor, i) => (
                                    <Option value={doctor.name}>
                                      {doctor.name}
                                    </Option>
                                  ))
                                ) : (
                                  <Option></Option>
                                )}
                              </Select>
                            )}
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col xl={2} md={0} xs={0}></Col>
                  <Col xl={10} md={24}>
                    <Row>
                      <Col xl={2} md={2}></Col>

                      <Col md={12} xl={13}>
                        <span className="roi--label-section">
                          <FormattedMessage id="email" />
                        </span>
                      </Col>
                      <Col md={7} xl={9}>
                        <Form.Item
                          name="email"
                          rules={[
                            {
                              required: true,
                              message: "Invalid email",
                              type: "email",
                            },
                          ]}
                        >
                          {ToolStore.selectedItem.dso ? (
                            <Input />
                          ) : (
                            <Input
                            // disabled={
                            //   doctor.name != "" && doctor.name != null
                            //     ? false
                            //     : true
                            // }
                            />
                          )}
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>{" "}
                </Row>
                {ToolStore.selectedItem.dso && (
                  <Row>
                    <Col xl={10} md={24}>
                      <Row>
                        <Col xl={2} md={2}></Col>
                        <Col md={12} xl={13}>
                          <span className="roi--label-section">
                            <FormattedMessage id="numberClinics" />
                          </span>
                        </Col>
                        <Col md={7} xl={9}>
                          <Form.Item
                            name="numberClinics"
                            defaultValue={5}
                            rules={[
                              {
                                validator: dataSuperior,
                              },
                            ]}
                          >
                            <Input type="number" />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                    <Col xl={2} md={0} xs={0}></Col>
                    <Col xl={10} md={24}></Col>{" "}
                  </Row>
                )}
              </>
            )}
            {step > 1 && (
              <>
                {" "}
                <Row>
                  <Col xl={10} md={24}>
                    <Row style={{ marginTop: "2vh" }}>
                      <Col xl={2} md={2}></Col>
                      <Col xl={19} md={19}>
                        <span
                          className="roi--label-section"
                          style={{ marginTop: "1vh" }}
                        >
                          <FormattedMessage id="roiFor" />
                        </span>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row
                  gutter={24}
                  style={{ marginTop: "2vh", marginLeft: "6vh" }}
                >
                  <Col span={8}>
                    <Checkbox
                      checked={ToolStore.conditions.smileMate}
                      onChange={() =>
                        ToolStore.onCheckSmileMate(
                          !ToolStore.conditions.smileMate
                        )
                      }
                    >
                      <span
                        className="roi--label-section"
                        style={{ marginTop: "1vh" }}
                      >
                        <FormattedMessage id="SmileMateFor" />
                      </span>
                    </Checkbox>
                  </Col>

                  <Col span={8}>
                    <Checkbox
                      checked={ToolStore.conditions.monitoringAligners}
                      onChange={() =>
                        ToolStore.onCheckMonitoringAligners(
                          !ToolStore.conditions.monitoringAligners
                        )
                      }
                    >
                      <span
                        className="roi--label-section"
                        style={{ marginTop: "1vh" }}
                      >
                        <FormattedMessage id="monitoringFor" />
                      </span>
                    </Checkbox>
                  </Col>
                  <Col span={8}>
                    <Checkbox
                      checked={ToolStore.conditions.monitoringBraces}
                      onChange={() =>
                        ToolStore.onCheckMonitoringbraces(
                          !ToolStore.conditions.monitoringBraces
                        )
                      }
                    >
                      <span
                        className="roi--label-section"
                        style={{ marginTop: "1vh" }}
                      >
                        <FormattedMessage id="bracesFor" />
                      </span>
                    </Checkbox>
                  </Col>
                </Row>
                <Row xl={24} md={24} style={{ marginTop: "2vh" }}>
                  {dsiplayseparateRole && (
                    <Col xl={10} md={24}>
                      <Row>
                        <Col xl={2} md={2}>
                          <Tooltip
                            color="#EBEBEA"
                            fontFamily="Gotham"
                            fontSize="20px"
                            style={{ textColor: "#6a6e80", textAlign: "right" }}
                            placement="rightTop"
                            title={
                              <FormattedMessage id="separateRoleTooltip" />
                            }
                          >
                            <img src="/images/icons/bull.svg" />
                          </Tooltip>
                        </Col>
                        <Col xl={22} md={22}>
                          <span className="roi--label-section">
                            <FormattedMessage id="separateRole" />
                          </span>
                        </Col>
                      </Row>
                      <Row style={{ marginTop: "2vh" }}>
                        <Col xl={12} md={12} style={{ textAlign: "center" }}>
                          <Radio
                            value={1}
                            checked={ToolStore.conditions.separateStaffRole}
                            onChange={() =>
                              ToolStore.toChangeSeparateRole(true)
                            }
                          >
                            <FormattedMessage id="yes" />
                          </Radio>
                        </Col>
                        <Col xl={12} md={12} style={{ textAlign: "center" }}>
                          <Radio
                            value={2}
                            checked={!ToolStore.conditions.separateStaffRole}
                            onChange={() =>
                              ToolStore.toChangeSeparateRole(false)
                            }
                          >
                            <FormattedMessage id="no" />
                          </Radio>
                        </Col>
                      </Row>
                    </Col>
                  )}
                  {dsiplayseparateTeensAdults && (
                    <Col xl={10} md={24}>
                      <Row>
                        <Col xl={2} md={2}>
                          <Tooltip
                            color="#EBEBEA"
                            fontFamily="Gotham"
                            fontSize="20px"
                            style={{ textColor: "#6a6e80", textAlign: "right" }}
                            placement="rightTop"
                            title={
                              <FormattedMessage id="separateTeensTooltip" />
                            }
                          >
                            <img src="/images/icons/bull.svg" />
                          </Tooltip>
                        </Col>
                        <Col xl={22} md={22}>
                          <span className="roi--label-section">
                            <FormattedMessage id="separateTeensAdults" />
                          </span>
                        </Col>
                      </Row>
                      <Row style={{ marginTop: "2vh" }}>
                        <Col xl={12} md={12} style={{ textAlign: "center" }}>
                          <Radio
                            value={1}
                            checked={ToolStore.conditions.separateTeensAdults}
                            onChange={() =>
                              ToolStore.toChangeSeparateTeens(true)
                            }
                          >
                            <FormattedMessage id="yes" />
                          </Radio>
                        </Col>
                        <Col xl={12} md={12} style={{ textAlign: "center" }}>
                          <Radio
                            value={2}
                            checked={!ToolStore.conditions.separateTeensAdults}
                            onChange={() =>
                              ToolStore.toChangeSeparateTeens(false)
                            }
                          >
                            <FormattedMessage id="no" />
                          </Radio>
                        </Col>
                      </Row>
                    </Col>
                  )}
                  {dsiplayshowHourly && (
                    <Col xl={10} md={24} style={{ marginTop: "2vh" }}>
                      <Row>
                        <Col xl={2} md={2}>
                          <Tooltip
                            color="#EBEBEA"
                            fontFamily="Gotham"
                            fontSize="20px"
                            style={{ textColor: "#6a6e80", textAlign: "right" }}
                            placement="rightTop"
                            title={<FormattedMessage id="showHourlyTooltip" />}
                          >
                            <img src="/images/icons/bull.svg" />
                          </Tooltip>
                        </Col>
                        <Col xl={22} md={22}>
                          <span className="roi--label-section">
                            <FormattedMessage id="showHourly" />
                          </span>
                        </Col>
                      </Row>
                      <Row style={{ marginTop: "2vh" }}>
                        <Col xl={12} md={12} style={{ textAlign: "center" }}>
                          <Radio
                            value={1}
                            checked={ToolStore.conditions.showHourly}
                            onChange={() => ToolStore.toChangeShowHourly(true)}
                          >
                            <FormattedMessage id="yes" />
                          </Radio>
                        </Col>
                        <Col xl={12} md={12} style={{ textAlign: "center" }}>
                          <Radio
                            value={2}
                            checked={!ToolStore.conditions.showHourly}
                            onChange={() => ToolStore.toChangeShowHourly(false)}
                          >
                            <FormattedMessage id="no" />
                          </Radio>
                        </Col>
                      </Row>
                    </Col>
                  )}
                </Row>
              </>
            )}

            {step < 3 && (
              <Form.Item>
                <div style={{ textAlign: "center" }}>
                  <Button
                    className="roi--button-primary"
                    htmlType="submit"
                    style={{
                      marginTop: "4vh",
                      textAlign: "center",
                      marginBottom: "2vh",
                    }}
                  >
                    <FormattedMessage id="next" />
                  </Button>
                </div>
              </Form.Item>
            )}
          </Form>
        </Collapse.Panel>
      </Collapse>
    );
  };

  const toValidatesField = () => {
    var json = formPractice.getFieldsValue();
    var res = false;
    for (var key in json) {
      var value = json[key];
      if (value == "" || null == value) {
        res = true;
      }
    }
    return res;
  };

  const toFormatStore = (res) => {
    var pretreatment = false;
    try {
      ResultsStore.setData(res);
      ResultsStore.setDisplayDetail(true);
      pretreatment = toJS(ResultsStore.data)
        .results.filter((a) => a.fieldName == "numberOfCases")[0]
        .value.filter((c) => c.fieldName == "preTreatment")[0].display;
      var results = toCalculateResult(res, {
        incLeads: false,
        incConversion: ResultsStore.conditions.smileMate,
        vision: true,
        usingGrowth:
          pretreatment == "true" || pretreatment == true ? true : false,
        usingRetention: ResultsStore.indicators.introduceRetention,
        alignersAverage: ResultsStore.numbersToTest.w24 > 0 ? true : false,
        alignersTeen: ResultsStore.numbersToTest.w25 > 0 ? true : false,
        bracesAverage: true,
        bracesTeen: ResultsStore.numbersToTest.w29 > 0 ? true : false,
        usingGrowthOther: true,
        usingRetentionOther: true,
      });
      return results;
    } catch (error) {
      console.log(error);
    }
  };

  const toAddOrUpdate = (status) => {
    const selectedItem = toJS(ToolStore.selectedItem);
    selectedItem.data.filter((a) => a.fieldName == "practiceProfile")[0].value =
      selectedItem.practiceProfile[0].value;
    selectedItem.data.filter((a) => a.fieldName == "numberOfCases")[0].value =
      selectedItem.numberOfCases[0].value;
    selectedItem.data.filter(
      (a) => a.fieldName == "conversionStatistics"
    )[0].value = selectedItem.conversionStatistics[0].value;
    selectedItem.data.filter(
      (a) => a.fieldName == "timeSpentOnTheExam"
    )[0].value = selectedItem.timeSpentOnTheExam[0].value;
    selectedItem.data.filter(
      (a) => a.fieldName == "workflowTreatment"
    )[0].value = selectedItem.workflowTreatement[0].value;
    selectedItem.data.filter(
      (a) => a.fieldName == "workflowTreatment"
    )[0].value = selectedItem.workflowTreatement[0].value;
    selectedItem.data.filter(
      (a) => a.fieldName == "goalsAndObjectives"
    )[0].value = selectedItem.goalsAndObjectives[0].value;
    selectedItem.status = status;
    selectedItem.assessmentId = id;

    var calculatedValues = toFormatStore({
      results: selectedItem.data,
      inputs: selectedItem.inputs,
      indicators: selectedItem.indicators,
      currency: selectedItem.currency,
    });

    if (id == -1) {
      setLoading(true);
      toAddAssessment(selectedItem, calculatedValues, clinic.id, doctor.id)
        .then((res) => {
          var l__json = {
            id: res.id,
            results: selectedItem.data,
            dt__created: moment(new Date()).format("YYYY-MM-DD"),
            dt__updated: moment(new Date()).format("YYYY-MM-DD"),
            templateId: selectedItem.key,
            status: status,
            dso: selectedItem.dso,
            inputs: selectedItem.inputs,
            indicators: selectedItem.indicators,
            currency: selectedItem.currency,
            calculatedValues: calculatedValues,
            clinicId: clinic.id,
            doctorId: doctor.id,
          };
          dbAssessments.add(l__json).then(
            (event) => {
              if (status == 1) {
                navigate("/results", {
                  state: { id: event },
                });
              } else {
                setLoading(false);

                successMsg(getTranslatedValue("infoSaved"));
              }
            },
            (error) => {
              console.log(error);
            }
          );
        })
        .catch((e) => {
          var l__json = {
            results: selectedItem.data,
            templateId: selectedItem.key,
            status: status == 1 ? 0 : 3,
            inputs: selectedItem.inputs,
            indicators: selectedItem.indicators,
            date: moment(new Date()).format("YYYY-MM-DD"),
            currency: selectedItem.currency,
            dso: selectedItem.dso,
            clinicId: clinic.id,
            doctorId: doctor.id,
            calculatedValues: calculatedValues,
          };
          dbAssessments.add(l__json).then(
            (event) => {
              if (status == 1) {
                navigate("/results", { state: { id: event } });
              } else {
                successMsg(getTranslatedValue("infoSaved"));
                setLoading(false);
              }
            },
            (error) => {
              console.log(error);
            }
          );
        });
    } else {
      toUpdateAssessment(
        selectedItem,
        calculatedValues,
        clinic.id,
        doctor.id
      ).then((res) => {
        var l__json = {
          id: res.id,
          results: selectedItem.data,
          dt__created: moment(new Date()).format("YYYY-MM-DD"),
          dt__updated: moment(new Date()).format("YYYY-MM-DD"),
          templateId: selectedItem.key,
          status: status,
          dso: selectedItem.dso,
          clinicId: clinic.id,
          doctorId: doctor.id,
          inputs: selectedItem.inputs,
          indicators: selectedItem.indicators,
          currency: selectedItem.currency,
          calculatedValues: calculatedValues,
        };
        dbAssessments.update(l__json).then(
          (x) => {
            if (status == 1) {
              navigate("/results", { state: { id: res.id } });
            } else {
              successMsg(getTranslatedValue("infoSaved"));
              setLoading(false);
            }
          },
          (error) => {
            console.log(error);
          }
        );
      });
    }
  };

  return (
    <div>
      <HeaderUser
        display={true}
        step={step}
        updateStep={() => setStep(step - 1)}
      />
      {loading ? (
        <ScreenLoader />
      ) : (
        <>
          {templates.length > 0 ? (
            <>
              <div style={{ textAlign: "center", marginTop: "10vh" }}>
                <Typography.Title level={2} className="roi--title-admin">
                  <Row>
                    <Col span="16">
                      <span
                        className="roi--label-section"
                        style={{ marginLeft: "2vh" }}
                      >
                        <FormattedMessage id="fillTheform" />
                      </span>
                    </Col>
                    <Col span="7" style={{ float: "right" }}>
                      <Button
                        icon={<img src="/images/icons/folder.svg" />}
                        className="roi--button-open-saved"
                        onClick={() => navigate("/forms")}
                      >
                        <span style={{ marginLeft: "5px" }}>
                          <FormattedMessage id="openForm" />
                        </span>
                      </Button>
                    </Col>
                  </Row>
                </Typography.Title>
              </div>

              <Tabs
                type="card"
                onChange={OnChange}
                hideAdd
                defaultActiveKey={activeKey}
              >
                {templates.map((pane, index) => (
                  <TabPane
                    className="roi--tab"
                    tab={pane.title}
                    key={pane.key}
                    closable={pane.closable}
                  >
                    {practiceProfile(ToolStore.selectedItem.practiceProfile)}
                    {step > 2 && null != ToolStore.selectedItem && (
                      <>
                        {ToolStore.selectedItem.dso && (
                          <Goals displayAll={false} ToolStore={ToolStore} />
                        )}

                        <NumberOfCases
                          displayAll={false}
                          ToolStore={ToolStore}
                        />

                        <ConversionStatistics
                          displayAll={false}
                          ToolStore={ToolStore}
                        />
                        <TimeSpent displayAll={false} ToolStore={ToolStore} />
                        <WorkflowTreatment
                          displayAll={false}
                          ToolStore={ToolStore}
                        />
                      </>
                    )}
                  </TabPane>
                ))}
              </Tabs>
              {step > 2 ? (
                <>
                  <div style={{ textAlign: "center" }}>
                    <Button
                      className="roi--button-primary"
                      style={{
                        marginTop: "4vh",
                        textAlign: "center",
                        marginBottom: "2vh",
                      }}
                      disabled={toValidatesField()}
                      onClick={() => toAddOrUpdate(1)}
                    >
                      <FormattedMessage id="estimate" />
                    </Button>

                    <Button
                      className="roi--button-third"
                      style={{
                        marginTop: "4vh",
                        marginLeft: "10vh",
                        textAlign: "center",
                        marginBottom: "2vh",
                      }}
                      disabled={toValidatesField()}
                      onClick={() => toAddOrUpdate(2)}
                    >
                      <FormattedMessage id="saveForLater" />
                    </Button>

                    <div style={{ paddingBottom: "2vh" }}>
                      <Row>
                        <Col span="1" />

                        <Col span="22">
                          <p className="roi--disclaimer-text">
                            <FormattedMessage id="disclaimer1" />
                            <br />

                            <FormattedMessage id="disclaimer2" />
                            <br />

                            <FormattedMessage id="disclaimer3" />
                          </p>
                          <hr style={{ width: "30%", margin: "auto" }} />

                          <p className="roi--disclaimer-text">
                            <br />
                            <FormattedMessage id="disclaimer4" />
                            <br />
                            <FormattedMessage id="disclaimer5" />
                            <br />
                            <FormattedMessage id="disclaimer6" />
                            <br />
                            <FormattedMessage id="disclaimer7" />
                            <br />
                            <FormattedMessage id="disclaimer8" />
                            <br />
                            <FormattedMessage id="disclaimer9" />
                            <br />
                            <FormattedMessage id="disclaimer10" />
                            <a href={getPDF()} target="_blank">
                              <FormattedMessage id="link" />
                            </a>
                          </p>
                        </Col>
                        <Col span="1" />
                      </Row>
                    </div>
                  </div>
                </>
              ) : (
                <div style={{ textAlign: "center" }}>
                  {/* <Button
                  className="roi--button-primary"
                  style={{
                    marginTop: "4vh",
                    textAlign: "center",
                    marginBottom: "2vh",
                  }}
                  //onClick={() =>  setStep(step + 1)}
                  onClick={() => {
                    validate();
                  }}
                >
                  <FormattedMessage id="next" />
                </Button> */}
                </div>
              )}
            </>
          ) : (
            <div style={{ textAlign: "center", marginTop: "10vh" }}>
              <Typography.Title level={2} className="roi--title-admin">
                <FormattedMessage id="contactAdmin" />
              </Typography.Title>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default inject("ToolStore")(observer(Tool));
